import * as origin from '@shopify/theme-cart'
import { getSizedImageUrl } from "@shopify/theme-images";

const store = {
	loaded: false,
	cart: false,
	currentProduct: false, // only available when viewing a singular product
	showCart: false,
	showSearch: false,
	showOverlay: false,
	cartLoading: false,
	checkoutLoading: false,
	searchOpen: false,
	showFreeShippingSpend: window.showFreeShippingCta || false,
	minFreeShippingSpend: window.freeShippingAmount || 0,
	helpers: {
		moneyFormat: function (input) {
			return new Intl.NumberFormat("en-AU", {
				style: "currency",
				currency: "AUD",
			}).format(input);
		},
		imageResizer: function (image, size) {
			return getSizedImageUrl(image, size);
		},
	},
	test() {
		console.log("store.js: test()");
	},
	reload() {
		console.log("store.js: reload()");
		//little helper function to quickly retrieve the Shopify cart and update local.
		this.cartLoading = true;
		origin.getState().then((res) => {
			this.setCart(res);
			this.cartLoading = false;
			this.loaded = true;
			console.log("store.js: Cart reloaded: ", res);
			console.log("store.js: cartCount: ", this.cartCount);
		});
	},
	get cartCount() {
		if (this.cart)
			return this.cart.items.reduce(
				(acc, item) => acc + item.quantity,
				0
			);
	},
	get cartItems() {
		if (this.cart) return this.cart.items;
	},
	setCart(cart) {
		console.log("store.js: setCart()");
		this.cart = cart;
		// this.cartCount = cart.item_count;
		console.log("SET CART: ", cart.item_count);
	},
	hideOverlay() {
		this.showOverlay = false;
		this.showCart = false;
	},
	toggleCart() {
		this.showCart = !this.showCart;
		this.showOverlay = !this.showOverlay;
	},
	toggleSearch() {
		this.showSearch = !this.showSearch;
	},
	get freeShippingSpendToGo() {
		const res = {
			enabled: (this.showFreeShippingSpend && this.minFreeShippingSpend > 0),
			reached: false,
			message: ''
		}
		if (this.cart) {
			const spendToGo = this.minFreeShippingSpend - this.cart.total_price;
			if (spendToGo > 0) {
				res.reached = false;
				res.message = 'Spend ' + this.helpers.moneyFormat(spendToGo / 100) + ' more to get FREE shipping!';
			} else {
				res.reached = true;
				res.message = 'Free shipping on this order!';
			}
		}
		return res
	},
	showCartOnLoad() {
		const urlParams = new URLSearchParams(window.location.search);
		const cartExists = urlParams.get("cart");
		return cartExists !== null ? true : false;
	},
	init() {
		console.log("store.js: init()");
		this.reload();
		window.Alpine.effect(() =>
			document.documentElement.classList.toggle(
				"overflow-y-hidden",
				this.showOverlay
			)
		);
	},
};

export { store, origin }
